import { Link } from "react-router-dom";
import { categories } from "@/mocks/site";

const colorMap: Record<string, { bg: string; text: string; iconBg: string }> = {
  primary: {
    bg: "bg-primary-50 hover:bg-primary-100",
    text: "text-primary-600",
    iconBg: "bg-primary-100",
  },
  accent: {
    bg: "bg-accent-50 hover:bg-accent-100",
    text: "text-accent-600",
    iconBg: "bg-accent-100",
  },
  secondary: {
    bg: "bg-secondary-50 hover:bg-secondary-100",
    text: "text-secondary-600",
    iconBg: "bg-secondary-100",
  },
};

export default function CategoryNav() {
  return (
    <section id="category-section" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            内容分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-lg mx-auto">
            六大内容品类，覆盖蘑菇tv创作者所需的全部资源类型
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group flex flex-col items-center text-center p-5 md:p-6 rounded-xl transition-all duration-300 border border-transparent cursor-pointer ${colors.bg}`}
              >
                <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl mb-3 transition-transform duration-300 group-hover:scale-110 ${colors.iconBg}`}>
                  <i className={`${cat.icon} text-xl md:text-2xl ${colors.text}`}></i>
                </div>
                <h3 className={`text-sm md:text-base font-semibold mb-1.5 ${colors.text}`}>
                  {cat.name}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}